import { render } from "./PhoneNumberField.vue?vue&type=template&id=2471812c&scoped=true&ts=true"
import script from "./PhoneNumberField.vue?vue&type=script&lang=ts"
export * from "./PhoneNumberField.vue?vue&type=script&lang=ts"

import "./PhoneNumberField.vue?vue&type=style&index=0&id=2471812c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/hekate/hekate/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2471812c"]])

export default __exports__